/**
 * This is a custom useDebounce hook using ref and memo, and the debounce function from lodash.
 * Params:
 * - callback function
 * - delay (in ms)
 */
import { useEffect, useMemo, useRef } from 'react';
import debounce from 'lodash/debounce';

export default function useDebounce(callback, delay) {
    const ref = useRef();

	useEffect(() => {
		ref.current = callback;
	}, [callback]);

	const debouncedCallback = useMemo(() => {
		const func = () => {
			ref.current?.();
		};

		return debounce(func, delay);
	}, []);

	return debouncedCallback;
}